import { ENDPOINT } from '~/constants';

import { isAbortError, type KyRequestOptions } from '@vestigas/data';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import { type ProjectByModelResponse } from './types';

/**
 * Fetches the project name for a given AI model.
 * @param modelId - The ID of the AI model to fetch the project name for.
 * @param options - Request options.
 * @returns The project name for the given AI model.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/get_project_by_model_get_project_by_model_get
 */
export const fetchProjectByModel = async (
  modelId: string,
  options?: KyRequestOptions,
) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.GET_PROJECT_BY_MODEL(), {
        searchParams: {
          modelId,
          forceRefresh: false,
        },
        ...options,
      })
      .json<ProjectByModelResponse>();

    return response;
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }

    log.error({
      message: 'Error fetching project name for AI model',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
